import React, { FC } from 'react'

export interface ITechnologyProps {
  index: number
  title: string
  description?: string
  open: boolean
  onClick: () => void
}

const Technology: FC<ITechnologyProps> = ({
  index,
  title,
  description,
  open,
  onClick,
}) => {
  const buttonColorClass = open
    ? 'text-white bg-red'
    : 'text-mediumDarkGray hover:text-white hover:bg-red'
  const descriptionHeightClass = open ? 'pt-3' : 'h-0'
  return (
    <div className="mb-2 xl:mb-4">
      <button
        type="button"
        onClick={onClick}
        className={`group w-full text-left rounded-lg md:text-lg font-semibold transition-all duration-300 ease-in-out ${buttonColorClass} box-content py-2.5 px-5 -ml-5 cursor-pointer hover:translate-x-2`}
      >
        <span className="mr-5 inline-block transition-transform duration-300 group-hover:scale-110">{index < 10 ? `0${index}` : index}</span>
        {title}
      </button>
      {!!description && (
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className={`text-xs md:text-sm box-border text-ultraDarkGray font-semibold overflow-hidden transition-all duration-500 ease-in-out ${descriptionHeightClass} ${open ? 'opacity-100 max-h-[1000px]' : 'opacity-0 max-h-0'}`}
        />
      )}
    </div>
  )
}

export default Technology
